import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { P1, FormFieldWrap, Input, Alert } from '@zooplus/ui-components';
import { useTranslation } from '../../../../hooks/useTranslations.js';
import { useConfig } from '../../../../providers/ConfigProvider.js';
import { useFormContext } from '../../../../providers/FormContextProvider.js';
import { persistCursorPosForSpacedInputValue, acceptOnlyNumber } from '../../../../utils/cardUtils.js';
import styles from './BancontactForm.module.scss.js';

const BancontactForm = () => {
    const { t } = useTranslation();
    const { getFormData, setFormData, initForm, clearForm } = useFormContext();
    const { config } = useConfig();
    const { bancontact } = config || {};
    const { adyenScriptIntegrity, adyenScriptSrc } = bancontact || {};
    const cardNumber = getFormData('bancontact', 'number');
    const fullName = getFormData('bancontact', 'holderName');
    const month = getFormData('bancontact', 'expirationMonth');
    const year = getFormData('bancontact', 'expirationYear');
    const dateHasError = month.hasError || year.hasError;
    const setMonth = (val) => {
        setFormData('bancontact', 'expirationMonth', acceptOnlyNumber(val));
    };
    const setYear = (val) => {
        setFormData('bancontact', 'expirationYear', acceptOnlyNumber(val));
    };
    useEffect(() => {
        const script = document.createElement('script');
        script.src = adyenScriptSrc;
        script.integrity = adyenScriptIntegrity;
        script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
        initForm('bancontact');
        setFormData('bancontact', 'brand', 'cartebancontact');
        return () => {
            clearForm();
        };
    }, []);
    useEffect(() => {
        //if user enters number more than 12, then it is automatically set to 01
        if (Number(month.value) > 12) {
            setFormData('bancontact', 'expirationMonth', '01');
        }
    }, [month.value]);
    //if user writes one digit number in month input field then 0 is added in front of the digit
    const updateMonth = () => {
        if (month.value.length == 1) {
            setFormData('bancontact', 'expirationMonth', `0${month.value}`);
        }
    };
    return (jsxs(Fragment, { children: [jsx(P1, { bold: true, children: "Cart Bancontact details" }), jsxs("form", { id: "payment-form", children: [jsx(FormFieldWrap, { className: styles.margin, isRequired: true, infoMessage: t('checkout.payment.secure'), errorMessage: cardNumber.hasError && t('checkout.payment.creditcard.error.form.cardnumber.invalid'), infoMessageIcon: "lock", labelText: t('checkout.payment.creditcard.card_number'), children: jsx(Input, { "data-testId": "bancontactNumber", onChange: (e) => setFormData('bancontact', 'number', persistCursorPosForSpacedInputValue(e.target, true)), hasError: cardNumber.hasError, inputProps: {
                                defaultValue: cardNumber.value,
                                placeholder: '**** **** **** **** ****',
                                className: 'formField',
                                maxLength: 23,
                                ['data-encrypted-name']: 'number',
                            } }) }), jsx(FormFieldWrap, { className: styles.margin, isRequired: true, labelText: t('checkout.payment.creditcard.holder_name'), errorMessage: fullName.hasError && t('checkout.payment.creditcard.name.invalid'), children: jsx(Input, { "data-testId": "bancontactHolderName", onChange: (e) => setFormData('bancontact', 'holderName', e.target.value), hasError: fullName.hasError, inputProps: {
                                value: fullName.value,
                                placeholder: 'Kim Mustermensch',
                                className: 'formField',
                                maxLength: 70,
                                ['data-encrypted-name']: 'holderName',
                            } }) }), jsx(FormFieldWrap, { className: styles.margin, isRequired: true, labelText: t('checkout.payment.creditcard.expiry_date'), errorMessage: dateHasError && t('checkout.payment.creditcard.expiry_date.invalid'), children: jsxs("div", { className: styles.dateContainer, children: [jsx(Input, { "data-testId": "bancontactMonth", inputProps: {
                                        value: month.value,
                                        placeholder: 'MM',
                                        className: 'formField',
                                        maxLength: 2,
                                        ['data-encrypted-name']: 'expiryMonth',
                                    }, hasError: dateHasError, onChange: (e) => setMonth(e.target.value), onBlur: () => updateMonth() }), jsx("span", { children: "/" }), jsx(Input, { "data-testId": "bancontactYear", inputProps: {
                                        value: year.value,
                                        placeholder: 'YYYY',
                                        className: 'formField',
                                        maxLength: 4,
                                        ['data-encrypted-name']: 'expiryYear',
                                    }, hasError: dateHasError, onChange: (e) => setYear(e.target.value) })] }) }), jsx(Alert, { "data-zta": "bc_text", children: "Legal text" })] })] }));
};

export { BancontactForm as default };
//# sourceMappingURL=BancontactForm.js.map
